import { P, match } from "ts-pattern";
const ImageControlType = "makeswift::controls::image";
const ImageControlValueFormat = {
  URL: "makeswift::controls::image::format::url",
  WithDimensions: "makeswift::controls::image::format::with-dimensions"
};
function Image(config = {}) {
  return { type: ImageControlType, config, version: 1 };
}
Image.Format = ImageControlValueFormat;
function copyImageData(value, context) {
  if (value == null)
    return value;
  return match(value).with(P.string, (id) => context.replacementContext.fileIds.get(id) ?? id).with({ type: "makeswift-file" }, ({ id }) => context.replacementContext.fileIds.get(id) ?? id).otherwise((val) => val);
}
export {
  Image,
  ImageControlType,
  ImageControlValueFormat,
  copyImageData
};
//# sourceMappingURL=image.js.map